export default "__VITE_ASSET__91204d2f__"